function fSticky() {
  const stickyElements = document.querySelectorAll('.sticky');
  Stickyfill.add(stickyElements);
}
